const notFoundRouter = {
  path: '/:pathMatch(.*)*',
  component: () => import('../views/404View.vue')
}

export { notFoundRouter }
